import ApplicationList from './Page/List'
import NewApplication from './Page/Application'


export default {
  routes: [
    {
      path: '/applications',
      name: 'ApplicationList',
      component: ApplicationList
    },
    {
      path: '/applications/new',
      name: 'NewApplication',
      component: NewApplication
    },

  ],
  menus: [
    {
      name: 'ApplicationList',
      label: 'Başvurular',
      icon: 'ti-microphone-alt',
      path: '/applications',
      roles: ['ROLE_ADMIN']
    },
    {
      name: 'NewApplication',
      label: 'Yeni Başvuru',
      icon: 'ti-plus',
      path: '/applications/new',
      roles: ['ROLE_ADMIN']
    },

  ],
}



// WEBPACK FOOTER //
// ./src/BundleApplication/index.js